import request from '@/config';

enum Apis {
	ModulesTree = `/api/sysmodule/getmenutrees`,
}

export const GetModuleTreesApi = (appType: string): Promise<IResponse> => request.post({ url: Apis.ModulesTree, data: { module_app: appType } });
